import React from 'react';
import LCVTutorDialog from './LCVTutorDialog';

const PHASE_LABELS = {
  tutorial: 'Tutorial',
  frontloading: 'Introduction',
  learning: 'I Do — Learning',
  workbook_ready: 'We Do — Workbook',
  workbook_exercise: 'We Do — Workbook',
  workbook_options: 'We Do — Review',
  knowledge_check: 'You Do — Check',
  knowledge_check_summary: 'Check Summary',
  mastery: 'Mastery Test',
  results: 'Results',
};

const LCVTutorPanel = ({
  text,
  phase,
  animationProgress,
  wordTimings = null,
  currentTimeMs = 0,
  paused = false,
  canPause = false,
  canSkip = false,
  fontSize,
  onFontSizeChange,
  onPause,
  onResume,
  onSkip,
  onReplay,
  canReplay = false,
  playbackRate = 1,
  canIncreasePlaybackRate = false,
  canDecreasePlaybackRate = false,
  onIncreasePlaybackRate,
  onDecreasePlaybackRate,
  volume = 100,
  canIncreaseVolume = false,
  canDecreaseVolume = false,
  onIncreaseVolume,
  onDecreaseVolume,
  isMuted = false,
  onToggleMute,
  playbackFinished = false,
}) => {
  if (!text) return null;

  return (
    <LCVTutorDialog
      className="lcv-tutor-panel"
      text={text}
      label={PHASE_LABELS[phase] || ''}
      animated
      progressRatio={animationProgress}
      wordTimings={wordTimings}
      currentTimeMs={currentTimeMs}
      showControls
      paused={paused}
      canPause={canPause}
      canSkip={canSkip}
      fontSize={fontSize}
      onFontSizeChange={onFontSizeChange}
      onPause={onPause}
      onResume={onResume}
      onSkip={onSkip}
      onRestart={onReplay}
      canReplay={canReplay}
      playbackRate={playbackRate}
      canIncreasePlaybackRate={canIncreasePlaybackRate}
      canDecreasePlaybackRate={canDecreasePlaybackRate}
      onIncreasePlaybackRate={onIncreasePlaybackRate}
      onDecreasePlaybackRate={onDecreasePlaybackRate}
      volume={volume}
      canIncreaseVolume={canIncreaseVolume}
      canDecreaseVolume={canDecreaseVolume}
      onIncreaseVolume={onIncreaseVolume}
      onDecreaseVolume={onDecreaseVolume}
      isMuted={isMuted}
      onToggleMute={onToggleMute}
      playbackFinished={playbackFinished}
    />
  );
};

export default LCVTutorPanel;
